import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { Article } from "../../types/article";

const updateOneArticle =
    (id: string, article: Article): AppThunk =>
    async (dispatch) => {
        const db = firebase.firestore();
        const docRef = db.collection("articles").doc(id);

        const updatedArticle: Article = {
            ...article,
            properties: {
                ...article.properties,
                updateTimestamp: Date.now(),
            },
        };

        await docRef.update(updatedArticle);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Updated one article with name ${article.properties.name?.en}`,
                },
            })
        );

        return;
    };

export default updateOneArticle;
